module.exports = __webpack_public_path__ + "img/full1-min.68ff20de.png";